export default [
  {
    path: "/modulos",
    component: () => import("@/views/modulos/Listar.vue"),
  },
  {
    path: "/modulos/crear",
    component: () => import("@/views/modulos/Crear.vue"),
  },
  {
    path: "/modulos/editar/:id",
    component: () => import("@/views/modulos/Editar.vue"),
  },
  {
    path: "/modulos/editarHoras/:id",
    component: () => import("@/views/modulos/horas/EditarHoras.vue"),
  },
  {
    path: "/modulos/editarPrecios/:id",
    component: () => import("@/views/modulos/precios/EditarPrecios.vue"),
  },
];
